import { http } from '@/shared/api/api-client';

import { KINDS } from '../lib/approval-kinds';
import type { InboxItem } from '../types/approval.types';

/**
 * The shared approvals inbox — GET /admin/approvals (approvals.read). Decisions
 * go to each type's own endpoint, which enforces the rules (no self-approval,
 * senior refunds, Admin-only types).
 */

interface AdminPage<T> {
  items: T[];
  totalCount: number;
}

export async function getInbox(
  params: { status: string; type?: string },
  signal?: AbortSignal,
): Promise<InboxItem[]> {
  const page = await http.get<AdminPage<InboxItem>>('/admin/approvals', {
    params: { ...params, page: 1, pageSize: 100 },
    signal,
  });
  return page.items;
}

/** Approve or reject (a second person), or cancel — withdraw — your own request. */
export async function decide(
  type: string,
  approvalId: number,
  decision: 'approve' | 'reject' | 'cancel',
  reason: string | null,
): Promise<void> {
  const kind = KINDS[type];
  if (!kind) throw new Error(`Unknown approval type ${type}.`);
  await http.post(`${kind.decisionPath(approvalId)}/${decision}`, { reason });
}
